import type { BenefitsDisplay, ItemProps, RootProps } from '@sunwebgroup/uds-ui/benefits'
import { Benefits as CssModulesBenefits } from '@sunwebgroup/uds-ui/benefits'
import { styled } from 'styled-components'

export type { BenefitsDisplay }
export type BenefitsItemProps = ItemProps

interface RootWrapperProps extends Omit<RootProps, 'display'> {
  $display?: BenefitsDisplay
}

export const Root = Object.assign(
  styled(CssModulesBenefits.Root).attrs<RootWrapperProps>(({ $display }) => ({
    display: $display,
  }))<RootWrapperProps>``,
  { displayName: 'Benefits.Root' },
)

export const Item = Object.assign(
  styled(CssModulesBenefits.Item).attrs<Omit<ItemProps, 'icon'> & { $icon?: ItemProps['icon'] }>(({ $icon }) => ({
    icon: $icon,
  }))<Omit<ItemProps, 'icon'> & { $icon?: ItemProps['icon'] }>``,
  { displayName: 'Benefits.Item' },
)
